import { Link } from "react-router-dom";
import { comics, genres } from "@/mocks/comics";

const popular = [...comics].sort((a, b) => b.heat - a.heat).slice(0, 8);

export default function PopularSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full">
              <i className="ri-fire-fill"></i>人气连载
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">大家都在追</h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">根据读者热度整理的追更榜单，热门日漫、国漫一次看个够。</p>
          </div>
          <Link
            to="/ranking"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-secondary-700 hover:text-secondary-800 whitespace-nowrap"
          >
            完整榜单 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-3 lg:grid-cols-4">
          {popular.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative rounded-2xl bg-background-50 border border-background-200 overflow-hidden hover:border-primary-200 transition-colors"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - ${comic.genre}人气连载漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute top-2 left-2 flex items-center gap-1 bg-foreground-950/80 text-background-50 text-[10px] font-bold px-2 py-0.5 rounded-md">
                  #{idx + 1}
                </span>
                <span className="absolute top-2 right-2 flex items-center gap-1 bg-background-50/90 text-foreground-800 text-[10px] font-medium px-1.5 py-0.5 rounded-md">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>{comic.rating}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">{comic.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 truncate">{comic.latestChapter}</p>
                <div className="mt-2 flex flex-wrap gap-1">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-[10px] text-secondary-700 bg-secondary-100 px-1.5 py-0.5 rounded-md">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}